import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';
import {
  WorkflowAutomation,
  WorkflowAutomationCreatePayload,
  WorkflowAutomationUpdatePayload,
} from '@core/workflow-automations-types';

@Injectable()
export class WorkflowAutomationsAnalytics extends AnalyticsBase {
  public readonly namespace = `WorkflowAutomations`;
  public readonly requireViewContext = true;

  public trackCreateNewAutomation(automation: WorkflowAutomationCreatePayload): void {
    this.track('CreateNew', {
      trigger: automation.trigger.type,
      actions: automation.actions.map(a => a.type),
      conditions: automation.conditions.map(c => c.type),
    });
  }

  public trackEditAutomation(
    automation: WorkflowAutomationUpdatePayload,
    initialAutomationData: WorkflowAutomation | null,
  ): void {
    const triggerChanged = initialAutomationData?.trigger.type !== automation.trigger.type;
    const actionsChanged =
      initialAutomationData?.actions.some(
        (action, index) => action.type !== automation.actions[index]?.type,
      ) || initialAutomationData?.actions.length !== automation.actions.length;
    const conditionsChanged =
      initialAutomationData?.conditions.some(
        (condition, index) => condition.type !== automation.conditions[index]?.type,
      ) || initialAutomationData?.conditions.length !== automation.conditions.length;
    this.track('EditAutomation', {
      triggerChanged,
      actionsChanged,
      conditionsChanged,
    });
  }
}
